import * as Yup from "yup";
import { CONFIRM_PASSWORD_REQUIRED, MIN_CHAR_LENGTH, PASSWORD_MUST_MATCH, PASSWORD_REQUIRED, PASSWORD_STRENGTH } from "../../constants/messages";
import { PASSWORD_MIN_CHAR, PASSWORD_REGEX } from "../../constants";

export const ResetPasswordSchema = Yup.object({
    password: Yup.string()
        .required(PASSWORD_REQUIRED)
        .min(PASSWORD_MIN_CHAR, MIN_CHAR_LENGTH)
        .transform((value: string) => value.trim())
        .matches(PASSWORD_REGEX, PASSWORD_STRENGTH),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), ""], PASSWORD_MUST_MATCH)
        .required(CONFIRM_PASSWORD_REQUIRED),
});